<div class="app-select-wrapper mobile-app-select d-flex justify-content-center column-gap-4 flex-wrap">
    @for (app of apps; track app.ID) {
        <div
            class="app-container d-flex flex-column slide-from-above"
            animate.enter="slide-in"
            animate.leave="slide-out">
            @if (app.Name !== "Help") {
                <button
                    mat-raised-button
                    class="mt-10 app-btn mobile-app-icon"
                    [routerLink]="app.Url"
                    (mouseenter)="isSettingsUrl(app.Url) && preloadSettingsPreferences()">
                    <div>
                        <mat-icon class="mat-70" color="primary">{{ app.Icon }}</mat-icon>
                        <div>
                            <span>{{ app.Name }}</span>
                        </div>
                    </div>
                </button>
            }
            <div class="menu-item-container d-flex justify-content-around">
                @for (menuItem of filteredMenuItems(app.ID); track menuItem.ID; let i = $index) {
                    <div class="menu-item">
                        <span class="menu-item-placeholder">•</span>
                        <button
                            class="menu-item-button"
                            [style.transition-delay]="(i + 1) * 0.05 + 's'"
                            color="primary"
                            mat-mini-fab
                            [routerLink]="menuItem.Url"
                            [matTooltip]="menuItem.Name">
                            <mat-icon class="no-margin">{{ menuItem.Icon }}</mat-icon>
                        </button>
                    </div>
                }
            </div>
        </div>
    }
</div>
